import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import DefiningPremiumLiving from "./sections/DefiningPremiumLiving";
import ImpactMetrics from "./sections/ImpactMetrics";
import KeyStatistics from "./sections/KeyStatistics";
import CoreSolutions from "./sections/CoreSolutions";
import FirmOverview from "./sections/FirmOverview";
import PropertyShowcase from "./sections/PropertyShowcase";
import OurServices from "./sections/OurServices";
import OurCorePhilosophy from "./sections/OurCorePhilosophy";
import EliteCredentials from "./sections/EliteCredentials";
import SecureYourEngagement from "./sections/SecureYourEngagement";
import Pricing from "./sections/Pricing";
import Footer from "@/reusable_sections/Footer";
import HowItWorks from "./sections/HowItWorks";
import ProblemSolutionCostComparison from "./sections/ProblemSolutionCostComparison";
export default function HomePage() {
  return <div>
      <Navigation />
      <DefiningPremiumLiving />
      <ProblemSolutionCostComparison />
      <Pricing />
      <ImpactMetrics />
      <KeyStatistics />
      <CoreSolutions />
      <FirmOverview />
      <PropertyShowcase />
      <OurServices />
      <OurCorePhilosophy />
      <HowItWorks />
      <EliteCredentials />
      <SecureYourEngagement />
      <Footer />
    </div>;
}